import { useMemo } from "react";
import Dropdown from "components/Dropdowns/Dropdown/Dropdown";
import { Apps } from "enums/Common";
import useAvailableApps from "hooks/useAvailableApps";
import { IDropdownOption } from "interfaces/Common";

interface OrderTypeDropdownProps {
  selected: Apps | undefined;
  onChange: (value: Apps) => void;
  disabled?: boolean;
}

const OrderTypeDropdown = ({ selected, onChange, disabled }: OrderTypeDropdownProps) => {
  const { canCreateAtHomeOrder, canCreateRemoteOrder } = useAvailableApps();

  const options = useMemo(
    (): IDropdownOption<Apps>[] => [
      ...(canCreateRemoteOrder
        ? [{ label: "LAB REMOTE (Staff Assisted Testing)", value: Apps.Remote }]
        : []),
      ...(canCreateAtHomeOrder
        ? [{ label: "LAB AT HOME (Patient Self-Testing)", value: Apps.AtHome }]
        : []),
    ],
    [canCreateAtHomeOrder, canCreateRemoteOrder]
  );

  return (
    <Dropdown
      hideClearButton
      useInputFieldStyle
      label="Order Type *"
      error={!selected}
      options={options}
      selected={selected}
      disabled={disabled}
      onChange={(value) => (value ? onChange(value) : undefined)}
    />
  );
};

export default OrderTypeDropdown;
